<template>
  <Loader v-if="loading" />
  <div v-else>
    <BaseFormGroup>
      <BaseFormLabel :for="`${_uid}-user_id`"> User * </BaseFormLabel>

      <BaseFormSelect
        :value="data.user_id"
        :options="options"
        :id="`${_uid}-user_id`"
        @input="setProps"
      />
    </BaseFormGroup>
  </div>
</template>

<script>
import { accountMembersClient } from '@/api/clients';

export default {
  props: {
    accountUuid: { type: String, required: true },
    defaultData: { type: Object, default: () => ({}) },
  },

  data() {
    return {
      loading: false,
      options: [],
      data: {
        user_id: null,
        ...this.defaultData,
      },
    };
  },

  created() {
    this.init();
  },

  methods: {
    async init() {
      this.loading = true;

      try {
        const { data = {} } = await accountMembersClient.list(this.accountUuid);

        if (data && data.data) {
          this.options = data.data.map(({ id, fullName }) => ({ label: fullName, value: id }));
        }
      } catch (error) {
        //
      }

      this.loading = false;
    },

    setProps(userId) {
      if (!userId) this.$emit('update-props', null);

      this.$emit('update-props', { user_id: userId });
    },
  },
};
</script>
